import styles from "./Terms.module.scss"
import useStrings from "../../localization/useStrings"
import native from "../../native/native"
import TermsButtons from "../TermsButtons/TermsButtons"

interface Props {
  lightContent?: boolean
}

const Terms = ({ lightContent }: Props) => {
  const strings = useStrings()

  return (
    <div
      className={`${styles.termsContainer} ${lightContent ? styles.light : ""}`}
    >
      <p>
        <b>{strings.subscriptionTerms}</b>
        <span>{strings.terms}</span>
      </p>
      <TermsButtons
        containerClass={styles.termsButtonsContainer}
        buttonClass={styles.termsButtons}
      />
    </div>
  )
}

export default Terms
